import { FC, PropsWithChildren } from 'react';
import { Typography } from 'antd';
import styles from './index.module.scss';

const SLabelTitle: FC<PropsWithChildren> = ({ children }) => {
  return <Typography className={styles.container}>{children}</Typography>;
};

export default SLabelTitle;
